import { ParticipantAction } from './actions';

export interface ParticipantState {
  participantByPanel: {
    [panelId: string]: string[];
  };
}

const initialState = {
  participantByPanel: {},
};

export function participantReducer(
  state: ParticipantState = initialState,
  action: ParticipantAction,
): ParticipantState {
  switch (action.type) {
    case 'FETCH_FAST_PARTICIPATION_SUCCESS':
      return {
        ...state,
        participantByPanel: {
          ...state.participantByPanel,
          [action.payload.panelId]: action.payload.ids,
        },
      };
    case 'DELETE_PARTICIPANTS':
      return {
        ...state,
        participantByPanel: {
          ...state.participantByPanel,
          [action.payload.panelId]:
            state?.participantByPanel?.[action.payload.panelId]?.filter(
              (id) => !action.payload.participantIds.includes(id),
            ) || [],
        },
      };
    case 'NEW_PARTICIPANT':
      if (!action.payload.panelId) {
        return state;
      }
      return {
        ...state,
        participantByPanel: {
          ...state.participantByPanel,
          [action.payload.panelId]: [
            action.payload.id,
            ...(state.participantByPanel[action.payload.panelId] || []),
          ],
        },
      };
    default:
      return state;
  }
}

export const PARTICIPANT_MODULE_KEY: 'participant' = 'participant';
export type ParticipantGlobalState = {
  [PARTICIPANT_MODULE_KEY]: ParticipantState;
};
